"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@emotion/react");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = function styles(theme) {
  return /*#__PURE__*/(0, _react2.css)({
    html: {
      webkitFontSmoothing: 'antialiased',
      mozOsxFontSmoothing: 'grayscale',
      boxSizing: 'border-box'
    },
    body: {
      margin: 0,
      fontFamily: theme.fonts.body,
      fontWeight: theme.fontWeights.body,
      color: theme.colors.text,
      backgroundColor: theme.colors.background
    },
    '*, *::before, *::after': {
      boxSizing: 'inherit'
    },
    'strong, b': {
      fontWeight: theme.fontWeights.bold
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:styles;");
};

var Normalize = function Normalize() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Global, {
    styles: styles
  });
};

Normalize.displayName = 'Normalize';
var _default = Normalize;
exports["default"] = _default;